import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { GameService } from '../core/services/game.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {

  public logged = false;
  public heMsisdn: any;
  public currentLevel: number;
  public currentStage: number;
  public redeem: boolean;
  howToPlay=false;
  lang: string = 'en';
  constructor(
    private translate: TranslateService,
    public router: Router,
    private gameservice: GameService,
  ) {}

  ngOnInit() {
    if (localStorage.getItem('msisdn') != null) {
      this.logged = true;
    }

    this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
  }

  startGame() {
    if (this.logged) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }

}
